import CalculateNextWorkingDay from '../../utils/CalculateNextWorkingDay.js'
let defaultEstimate = ''
CalculateNextWorkingDay(1).then(response => {
	defaultEstimate = response
})

// Initial state
function initialState() {
	return {
		estimated: defaultEstimate,
		adjustedEstimated: '',
		adjustedEstimatedReason: '',
		action: '',
		dispatched: '',
		deliverySpeed: ''
	}
}

const state = initialState()

// Getters
const getters = {
	estimatedCompletion: (state) => {
		return state.estimated
	},
	adjustedEstimatedCompletion: (state) => {
		return state.adjustedEstimated
	},
	adjustedEstimatedCompletionReason: (state) => {
		return state.adjustedEstimatedReason
	},
	actionDate: (state) => {
		return state.action
	},
	dispatched: (state) => {
		return state.dispatched
	},
	deliverySpeed: (state) => {
		return state.deliverySpeed
	}
}

// Actions
const actions = {
	resetState ({ state, commit }) {
		commit('reset')
	},
	addEstimatedDate ({ state, commit }, dateString) {
		commit('setEstimatedDate', dateString)
	},
	addAdjustedEstimatedDate ({ state, commit }, adjustedDetails) {
		commit('setAdjustedEstimatedDate', adjustedDetails)
	},
	addActionDate ({ state, commit }, dateString) {
		commit('setActionDate', dateString)
	},
	removeAdjustedEstimatedDate ({ state, commit }) {
		commit('setAdjustedEstimatedDate', {'dateString':'', 'reason':''})
	},
	removeActionDate ({ state, commit }) {
		commit('setActionDate', '')
	},
	addDispatchedDate ({ state, commit }, dateString) {
		commit('setDispatchedDate', dateString)
	},
	removeDispatchedDate ({ state, commit }) {
		commit('setDispatchedDate', '')
	},
	addDeliverySpeed ({ state, commit }, delivery) {
		commit('setDeliverySpeed', delivery)
	}
}

// Mutations
const mutations = {
	reset (state) {
		// acquire initial state
		const s = initialState()
		Object.keys(s).forEach(key => {
			state[key] = s[key]
		})
	},
	setEstimatedDate (state, dateString) {
		state.estimated = dateString
	},
	setAdjustedEstimatedDate (state, adjustedDetails) {
		state.adjustedEstimated = adjustedDetails.dateString
		state.adjustedEstimatedReason = adjustedDetails.reason
	},
	setActionDate (state, dateString) {
		state.action = dateString
	},
	setDispatchedDate (state, dateString) {
		state.dispatched = dateString
	},
	setDeliverySpeed (state, delivery) {
		state.deliverySpeed = delivery
	}
}

export default {
	namespaced: false,
	state,
	getters,
	actions,
	mutations
}
